import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetch, openContract } from '../../actions/contracts/inbox';
import {
    shouldFetchSelector,
    fetchingSelector,
    listSelector,
    paginationSelector
} from '../../selectors/contracts/inbox';
import Table from '../../components/tables/Table';
import { CONTRACTS_INBOX_HEADERS, CONTRACT_TYPES } from '../../constants/settings';
import SignState from '../../components/application/contracts/SignState';
import { msToTime } from '../../lib/date.utils';
import { compact, get } from 'lodash';
import { canAccessClearanceInInbox, canAccessPerformanceInInbox } from '../../selectors/authentication';
import AdminTabs from '../admin/AdminTabs';
import { currentTabSelector } from '../../selectors/admin/tabs';

const TAB_CONTRACT_TYPE_MAPPING = {
    0: CONTRACT_TYPES.CLEARANCE,
    1: CONTRACT_TYPES.PERFORMANCE
};

class ContractsInbox extends Component {
    componentDidMount() {
        this._fetch();
    }

    componentDidUpdate() {
        this._fetch();
    }

    _fetch = () => {
        if (
            this.props.shouldFetch &&
            (this.props.canAccesPerformanceContracts || this.props.canAccesClearanceContracts)
        ) {
            this.props.fetch(
                this.props.pagination,
                !this.props.canAccesClearanceContracts
                    ? CONTRACT_TYPES.PERFORMANCE
                    : TAB_CONTRACT_TYPE_MAPPING[this.props.currentTab || 0]
            );
        }
    };

    _enableRowFunction = () => true;

    _transformRows = {
        artistName: (_, d) => get(d, 'artist.name', ''),
        eventName: (_, d) => get(d, 'event.name', ''),
        performances: p => (p || []).map(x => x.name).join(', '),
        state: (_, d) => <SignState state={get(d, 'version.state', '')} />,
        updatedAt: st => msToTime(st, true)
    };

    _changePage = (page, pageSize) => {
        if (this.props.pagination.pageSize !== pageSize) {
            this.props.fetch(
                { ...this.props.pagination, page: 1, pageSize },
                TAB_CONTRACT_TYPE_MAPPING[this.props.currentTab || 0]
            );
        } else {
            this.props.fetch(
                { ...this.props.pagination, page, pageSize },
                TAB_CONTRACT_TYPE_MAPPING[this.props.currentTab || 0]
            );
        }
    };

    _changeTab = tab => {
        this.props.fetch(
            { ...this.props.pagination, page: 1 },
            !this.props.canAccesClearanceContracts ? CONTRACT_TYPES.PERFORMANCE : TAB_CONTRACT_TYPE_MAPPING[tab || 0]
        );
    };

    _renderContentWithTabs = () => {
        return (
            <div className="ckp-contracts-inbox">
                <AdminTabs
                    disable={false}
                    labels={compact([
                        this.props.canAccesClearanceContracts ? 'Clearance Contracts' : null,
                        this.props.canAccesPerformanceContracts ? 'Performance Contracts' : null
                    ])}
                    onTabSwitch={this._changeTab}
                    content={compact([
                        this.props.canAccesClearanceContracts ? (
                            <React.Fragment key={'contracts-inbox-clearance-contracts-tab'}>
                                <Table
                                    pagination={true}
                                    className="is-front-end"
                                    headers={CONTRACTS_INBOX_HEADERS}
                                    loading={this.props.isFetching}
                                    data={this.props.inbox}
                                    noSelect={true}
                                    onOpen={this.props.openContract}
                                    canOpenRows={true}
                                    transformFunctions={this._transformRows}
                                    enableRowFunction={this._enableRowFunction}
                                    paginationChange={this._changePage}
                                    resultsPerPage={this.props.pagination.pageSize}
                                    currentPage={this.props.pagination.page}
                                    totalPages={this.props.pagination.totalPages}
                                />
                            </React.Fragment>
                        ) : null,
                        this.props.canAccesPerformanceContracts ? (
                            <React.Fragment key={'contracts-inbox-performance-contracts-tab'}>
                                <Table
                                    pagination={true}
                                    className="is-front-end"
                                    headers={CONTRACTS_INBOX_HEADERS}
                                    loading={this.props.isFetching}
                                    data={this.props.inbox}
                                    noSelect={true}
                                    onOpen={this.props.openContract}
                                    canOpenRows={true}
                                    transformFunctions={this._transformRows}
                                    enableRowFunction={this._enableRowFunction}
                                    paginationChange={this._changePage}
                                    resultsPerPage={this.props.pagination.pageSize}
                                    currentPage={this.props.pagination.page}
                                    totalPages={this.props.pagination.totalPages}
                                />
                            </React.Fragment>
                        ) : null
                    ])}
                />
            </div>
        );
    };

    _renderContentWithoutTabs = () => {
        return (
            <React.Fragment>
                <h1 className="ckp-ts-h1 ckp-contracts-inbox-title">My Contracts</h1>
                <React.Fragment key={'contracts-inbox-clearance-contracts-tab'}>
                    <Table
                        pagination={true}
                        className="is-front-end"
                        headers={CONTRACTS_INBOX_HEADERS}
                        loading={this.props.isFetching}
                        data={this.props.inbox}
                        noSelect={true}
                        onOpen={this.props.openContract}
                        canOpenRows={true}
                        transformFunctions={this._transformRows}
                        enableRowFunction={this._enableRowFunction}
                        paginationChange={this._changePage}
                        resultsPerPage={this.props.pagination.pageSize}
                        currentPage={this.props.pagination.page}
                        totalPages={this.props.pagination.totalPages}
                    />
                </React.Fragment>
            </React.Fragment>
        );
    };

    render() {
        return this.props.canAccesPerformanceContracts
            ? this._renderContentWithTabs()
            : this._renderContentWithoutTabs();
    }
}

const mapStateToProps = state => ({
    currentTab: currentTabSelector(state),
    inbox: listSelector(state),
    isFetching: fetchingSelector(state),
    shouldFetch: shouldFetchSelector(state),
    pagination: paginationSelector(state),
    canAccesPerformanceContracts: canAccessPerformanceInInbox(state),
    canAccesClearanceContracts: canAccessClearanceInInbox(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetch, openContract }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContractsInbox);
